var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-btn',{staticClass:"white--text",attrs:{"absolute":"","color":"#14ad95","fab":"","large":"","right":"","top":""},on:{"click":_vm.addToCart}},[_c('v-icon',[_vm._v("mdi-cart")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }